import React from 'react';

import { Select } from '../../select';

type PageLimitProps = {
  pageSize: number;
  rowsPerPage: number[];
  onPageSizeChange?: (value: number) => void;
};

export const PageLimit = ({
  pageSize,
  rowsPerPage,
  onPageSizeChange,
}: PageLimitProps): JSX.Element => (
  <>
    <label htmlFor="pagination" className="text-gray-400">
      Rows per page:
    </label>
    <Select
      id="pagination"
      fullWidth={false}
      value={pageSize}
      height="sm"
      onChange={(event) => onPageSizeChange?.(Number(event.target.value))}
    >
      {rowsPerPage.map((pageSize) => (
        <option key={pageSize} value={pageSize}>
          {pageSize}
        </option>
      ))}
    </Select>
  </>
);
